import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';

import { FullLayoutComponent } from "./layouts/full-layout/full-layout.component";
import { CommonLayoutComponent } from "./layouts/common-layout/common-layout.component";

import { FullLayout_ROUTES } from "./modules/shared/routes/full-layout.routes";
import { CommonLayout_ROUTES } from "./modules/shared/routes/common-layout.routes";

//Routes
const appRoutes: Routes = [
  // {
  //     path: '',
  //     redirectTo: '/full',
  //     pathMatch: 'full',
  // },
  {
    path: 'full',
    component: FullLayoutComponent,
    children: FullLayout_ROUTES
  },
  {
    path: '',
    component: CommonLayoutComponent,
    children: CommonLayout_ROUTES
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: PreloadAllModules,
      // useHash: true,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {
}
